import React, { useEffect, useRef, useState } from "react";
import FocusWrap from "../hooks/FocusWrap";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label from "../ui/Label";
import { pubCall } from "../utils/PubSub";
import Confirm from "../popups/Confirm";
import Input from "../ui/Input";
import Status from "../ui/Status";
import PriceField from "../ui/PriceField";
import { showError, showMessage } from "../ui/Message";
import { ROUTES } from "../utils/Routes";
import { VALIDATE } from "../utils/Validators";
import { CopyIcon, InfoIcon} from "../utils/Icons";
import { drawPrice, getSaved, addCellDashes } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Row from "../ui/Row";
import dayjs from "dayjs";
import { createModal } from "../hooks/createModal";
import CustomerType from "../popovers/CustomerType";
import PhoneType from "../popovers/PhoneType";

export default function CustomerDetails(props) {

    const { 
        controller = "", 
        setData = () => { },
        setSelected = () => { }, 
        switchEdit = () => { },
        edit = false, 
        updateRow = () => { },
        isnew = false,
        route = "", 
        signal = {},
        callback = () => { },
    } = props;

    const refs = useRef([]);
    const [index, setIndex] = useState(getSaved("customers_start_field") || "name");

    const [customer_data, setCustomerData] = useState(props.selected || {});

    const {
        address_1 = "634 Thorneloe Road",
        address_2 = "",
        attention = "start date: Aug24 2020",
        bill_to = "Bill To",
        bo = "N",
        cancel = 0,
        city = "",
        combine_po = "Y",
        communication_preference = "", // pref
        country = "CANADA",
        credit_limit = 0,
        discount = 30,
        edi_codes = "",
        email = "",
        enter_date = "2020-09-28",
        fax = "", // phone3 
        frequent_buyer = true,
        frequent_buyer_point = 0,
        frequent_buyer_recipient = "",
        get_deposit = false,
        interest_1 = "STAFF", // class
        interest_2 = "",
        interest_3 = "",
        interest_4 = "",
        last_order_date = "2024-07-12",
        location = "0",
        name = "Hunter, Mike",
        note = "start date: Aug24 2020",
        note_keynum = "",
        notes = "BM STAFF",
        over_due = " ",
        person_id = "0193046b-be5b-7501-8365-68de0d568519",
        phone = "",
        phone_2 = "",
        postal_code = "V1W 4P6",
        province = "BC",
        rep = "",
        sales_3 = 43,
        sales_last = 14,
        sales_this = 9,
        san = "", //ol account
        ship_to = "104303",
        ship_via = "",
        shop = "", // custType
        tax_exempt = "",
        tax_exempt_2 = "",
        tax_group_code = "",
        term = "",
        web_access = " "
    } = customer_data;


    const tabs = [
        { key: "attention", autoselect: true },
        { key: "ship_to", autoselect: true },
        { key: "shop", autoselect: true },
        { key: "name", autoselect: true },
        { key: "phone", autoselect: true },
        { key: "phone_2", autoselect: true },
        { key: "fax", autoselect: true },
        { key: "email", autoselect: true },
        { key: "communication_preference", autoselect: true },
        { key: "address_1", autoselect: true },
        { key: "address_2", autoselect: true },
        { key: "city", autoselect: true },
        { key: "province", autoselect: true },
        { key: "postal_code", autoselect: true },
        { key: "country", autoselect: true },
        { key: "san", autoselect: true },
        { key: "rep", autoselect: true },
        { key: "interest_1", autoselect: true },
        { key: "interest_2", autoselect: true },
        { key: "interest_3", autoselect: true },
        { key: "interest_4", autoselect: true },
        { key: "bill_to", autoselect: true },
        { key: "discount", autoselect: true },
        { key: "tax_group_code", autoselect: true },
        { key: "credit_limit", autoselect: true },
        { key: "tax_exempt", autoselect: true },
        { key: "tax_exempt_2", autoselect: true },
        { key: "ship_via", autoselect: true },
        { key: "term", autoselect: true },
        { key: "notes", autoselect: true },
        { key: "note", autoselect: true },
        { key: "combine_po", autoselect: true },
        { key: "get_deposit", autoselect: true },
        { key: "sales_3", autoselect: true },
        { key: "sales_last", autoselect: true },
        { key: "sales_this", autoselect: true },
    ];

    
    const drawMessage = () => {
        switch (index) {
            case "attention": return <>An optional contact name (usually for a company).</>;
            case "ship_to": return <>Unique account # for customer.</>;
            case "shop": return <>Customer Type <strong>{KBD.PAGE_UP.label}</strong> to access types.</>;
            case "name": return <>Usually last, first name.</>;
            case "phone": return <>Primary phone number and type (C,H,W,F). <strong>{KBD.PAGE_UP.label}</strong> for menu.</>;
            case "phone_2": return <>2nd phone number and type (C,H,W,F). <strong>{KBD.PAGE_UP.label}</strong> for menu.</>;
            case "fax": return <>3rd phone number (or Fax) and type (C,H,W,F). <strong>{KBD.PAGE_UP.label}</strong> for menu.</>;
            case "email": return <></>;
            case "communication_preference": return <>Default for customer notifications via: Eml,Txt,Cel,Phn,Hom,Wrk,No</>;
            case "address_1": return <></>;
            case "address_2": return <></>;
            case "city": return <></>;
            case "province": return <>Province/state</>;
            case "postal_code": return <>Postal/zip code</>;
            case "country": return <></>;
            case "san": return <>Customer's online account (or SAN for book industry partners)</>;
            case "rep": return <>Cost (usually automatically calculated when receiving).</>;
            case "interest_1": return <>Up to four 8-character tags for this customer. 'KEEP' prevents auto-deletion</>;
            case "interest_2": return <>Up to four 8-character tags for this customer. 'KEEP' prevents auto-deletion</>;
            case "interest_3": return <>Up to four 8-character tags for this customer. 'KEEP' prevents auto-deletion</>;
            case "interest_4": return <>Up to four 8-character tags for this customer. 'KEEP' prevents auto-deletion</>;
            case "bill_to": return <>Where invoices are sent. Enter the name of an existing customer</>;
            case "tax_group_code": return <>Total # copies returned.</>;
            case "notes": return <>1st line notes. Do not store credit card# here (use designated CC# field)</>;
            case "note": return <>2nd line notes</>;
            case "ship_via": return <>Freeform shipping method (e.g. POST)</>;
            case "combine_po": return <>If Orders with different PO#s will be posted to a single invoice in the POS.</>;
            case "get_deposit": return <>When {"<R>"}eserving, a warning will appear if this is Y </>;
            case "term": return <>Freeform payment terms (e.g. Net30)</>;
            case "discount": return <>The discount entered will be the default in POS for this cust.</>;
            case "credit_limit": return <>-1 = no credit allowed, 0 = no limit, -3 = Alert in POS for terms</>;
            case "tax_exempt": return <>Y/N if product may be returned to supplier.</>;
            case "tax_exempt_2": return <>Total # copies returned.</>;
        }
    }
    

    const formatPhone = (val) => {
        const [num, ...rest] = (val || "").split(" ");
        return addCellDashes(num) + (rest.length ? " " + rest.join(" ") : "");
    };

    const capitalizeName = (name) => {
        return (name || "")
            .split(" ")
            .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : word)
            .join(" ");
    };

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: (edit && tabs.find(item => item.key === index)),
        controlled: true,
        autoselect: tabs.find(item => item.key === index)?.autoselect || false,
        onChange: (e) => {
            setCustomerData({ ...customer_data, [index]: e })
        }
    });

    const nameSuggestionShown = useRef(false);
    const saving = useRef(false);

    const nameSuggestion = (onComplete) => {
        if (nameSuggestionShown.current) return false;
        const currentName = (refs.current["name"]?.value || name).trim();
        const parts = currentName.split(/\s+/);
        if (currentName.includes(",") || parts.length < 2) {
            return false;
        }

        const last = capitalizeName(parts[parts.length - 1]);
        const first = capitalizeName(parts.slice(0, parts.length - 1).join(" "));
        const suggested = `${last}, ${first}`;

        nameSuggestionShown.current = true;
        window.bm_state.value = ROUTES.HELPERS.CUSTOMER_NAME;
        refs.current["name"].blur();
        createModal({
            alert: true,
            component:
            <Confirm 
                controller={controller} 
                events={[KBD.Y, KBD.N]} 
                title = "Suggestion"
                description={<>
                    Change name for consistency?<div className="shim" /><div className="shim" />
                    <Space><div className="text" style={{"width" : "32px"}}>from:</div> <strong>{currentName}</strong></Space>
                    <div className="shim" />
                    <Space><div className="text" style={{"width" : "32px"}}>to:</div><strong>{suggested}</strong></Space>
                    <div className="shim" />
                    </>} 
                signal={signal} 
                route={ROUTES.HELPERS.CUSTOMER_NAME} 
            />, 
            closable: true, 
            callback: (e) => {
                window.bm_state.value = ROUTES.CUSTOMER.EDIT;
                const resolvedName = e === true ? suggested : customer_data.name;
                if (e === true) {
                    setCustomerData({ ...customer_data, "name": suggested });
                }
                onComplete({ ...customer_data, name: capitalizeName(resolvedName) });
            }
        });
        return true;
    }

    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const performSave = (dataToSave) => {

        if (!dataToSave.name) { showMessage("Name Required"); return; }
        if (saving.current) return;
        saving.current = true;
        pubCall((isnew) ? "customer.create" : "customer.edit", { customer_info: dataToSave, ...(!isnew ? { ship_to: dataToSave.ship_to } : {}) }, (_s, _r) => {
            if (_s) {
                if (isnew) {
                    pubCall("customer.getInitial", {ship_to: _r.ship_to, limit: 45, sort: "name" }, (_su, _re) => {
                        setData(_re.rows_previous.concat(_re.rows_next));
                        setTimeout(() => {
                        setSelected(_re.rows_next[0]);
                        switchEdit();
                        callback(_r);
                        }, 10);
                    })
                } else {
                    setCustomerData(_r);
                    updateRow(_r, customer_data.ship_to);
                    switchEdit();
                }   
            } else {
                showError(_r);
            }
            saving.current = false;
        })
    }

    const checkPhoneAndSave = (dataToSave) => {
        if (isnew && dataToSave.phone.split(" ")[0] && !dataToSave.phone.split(" ")[1]) {
            setIndex("phone");
            setTimeout(() => {
                window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
                refs.current["phone"]?.blur();
                createModal({
                    offset: [0, -80],
                    component: <PhoneType value={dataToSave.phone} route={ROUTES.HELPERS.CUSTOMER_TYPES} />,
                    refElement: refs.current["phone"],
                    closable: true,
                    callback: (e) => {
                        window.bm_state.value = ROUTES.CUSTOMER.EDIT;
                        if (e !== false) {
                            const updatedPhone = dataToSave.phone.split(" ")[0] + " " + e;
                            dataToSave.phone = updatedPhone;
                            setCustomerData({ ...customer_data, phone: updatedPhone });
                            performSave(dataToSave);
                        }
                        refs.current["phone"]?.focus();
                    }
                });
            }, 10);
            return;
        }
        performSave(dataToSave);
    }

    const saveCustomer = () => {
        const dataToSave = { ...customer_data, name: capitalizeName(customer_data.name) };
        if (isnew && nameSuggestion((dataToSave) => {
            checkPhoneAndSave(dataToSave);
        })) {
            return;
        }
        checkPhoneAndSave(dataToSave);
    }

    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }
        const actions = [
            { key: KBD.ESCAPE, action: () => { setCustomerData(props.selected); switchEdit(); } },
            { key: KBD.ENTER, action: (e) => next(e) },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.PAGE_DOWN, action: (e) => { saveCustomer() } },
            { key: KBD.PAGE_UP, action: (e) => { openPopover() } },
            { key: KBD.ARROW_DOWN, action: (e) => next(e) },
            { key: KBD.ARROW_UP, action: (e) => prev(e) },
        ];
        const cleanup = listen(controller, ROUTES.CUSTOMER.EDIT, actions, (e) => {

            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V, KBD.F9, KBD.F6], [], [KBD.F6, KBD.CTRL_C, KBD.CTRL_V], null);
        return cleanup;
    }, [index, customer_data]);

    useEffect(() => {

        setCustomerData(props.selected || {});
        nameSuggestionShown.current = false;
    }, [props.selected]);

    const openPopover = () => {

        switch (index) {

            // case "shop":
            //     window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
            //     refs.current["shop"].blur();
            //     createModal({
            //         offset: [0, -80],
            //         component: 
            //             <CustomerType 
            //                 value={refs.current["shop"].value} 
            //                 route={ROUTES.HELPERS.CUSTOMER_TYPES} 
            //             />,  
            //             closable: true, 
            //             title: "Customer Types", 
            //             callback: (e) => {
            //                 window.bm_state.value = ROUTES.CUSTOMER.EDIT;
            //             }
            //     })
            // break;

            case "phone":
                if (!phone.split(" ")[0]){
                    return;
                }
                window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
                refs.current["phone"].blur();
                createModal({
                    offset: [0, -80],
                    component: <PhoneType value={refs.current["phone"].value} route={ROUTES.HELPERS.CUSTOMER_TYPES} />, 
                        refElement: refs.current["phone"],
                        closable: true, 
                        callback: (e) => {
                            window.bm_state.value = ROUTES.CUSTOMER.EDIT;
                            if (e !== false) { setCustomerData({ ...customer_data, "phone": phone.split(" ")[0] + " " + e }) }

                        refs.current[index].focus();
                    }
                })
            break;

            case "phone_2":
                if (!phone_2.split(" ")[0]){
                    return;
                }
                window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
                refs.current["phone_2"].blur();
                createModal({
                    offset: [0, -80],
                    component: <PhoneType value={refs.current["phone_2"].value} route={ROUTES.HELPERS.CUSTOMER_TYPES} />, refElement: refs.current["phone_2"], closable: true, callback: (e) => {
                        window.bm_state.value = ROUTES.CUSTOMER.EDIT;
                        if (e !== false) { setCustomerData({ ...customer_data, "phone_2": phone_2.split(" ")[0] + " " + e }) }

                        refs.current[index].focus();
                    }
                })
            break;

            case "fax":
                if (!fax.split(" ")[0]){
                    return;
                }
                window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
                refs.current["fax"].blur();
                createModal({
                    offset: [0, -80],
                    component: <PhoneType value={refs.current["fax"].value} route={ROUTES.HELPERS.CUSTOMER_TYPES} />, refElement: refs.current["fax"], closable: true, callback: (e) => {
                        window.bm_state.value = ROUTES.CUSTOMER.EDIT;
                        if (e !== false) { setCustomerData({ ...customer_data, "fax": fax.split(" ")[0] + " " + e }) }

                        refs.current[index].focus();
                    }
                })
            break;
        }
    }


    const drawCard = () => {
        return (
            <>

                <Space grow size={8}>
                    <Label shrink={false} width={37}>Attn</Label>
                    <Input grow {...editProps("attention")} maxLength={20} value={attention} width={250} />
                    <Label><nobr>Act#</nobr></Label>
                    <Input {...(!isnew ? editProps("ship_to") : {})} className={(isnew) ? "dim" : "normal"} maxLength={8} uppercase value={ship_to} width={140} />
                    <Label><nobr>CustType</nobr></Label>
                    <Input {...editProps("shop")} style={{ "textAlign": "center" }} value={shop} width={25} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Name</Label>
                    <Input grow {...editProps("name")} validator={VALIDATE.EMPTY} maxLength={35} value={name} width={659} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Phone</Label>
                    <Input shrink={false} grow {...editProps("phone")} maxLength={16} value={(edit) ? phone : formatPhone(phone)} width={170} />
                    <Label width={37}>Phn2</Label>
                    <Input {...editProps("phone_2")} grow maxLength={16} value={(edit) ? phone_2 : formatPhone(phone_2)} width={170} />
                    <Label width={37}>Phn3</Label>
                    <Input {...editProps("fax")} grow maxLength={16} value={(edit) ? fax : formatPhone(fax)} width={170} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Email</Label>
                    <Input {...editProps("email")} value={email} width={466} />
                    <Label grow>Pref</Label>
                    <Input {...editProps("communication_preference")} maxLength={3} value={communication_preference} width={40} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Addr1</Label>
                    <Input {...editProps("address_1")} value={address_1} maxLength={35} width={363} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Addr2</Label>
                    <Input {...editProps("address_2")} value={address_2} maxLength={35} width={363} />

                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>City</Label>
                    <Input grow {...editProps("city")} value={city} maxLength={21} width={363} />

                    <Label width={30}>Prov</Label>
                    <Input shrink={false} {...editProps("province")} value={province} uppercase maxLength={2} width={50} />
                    <Label width={20}>PC</Label>
                    <Input shrink={false} {...editProps("postal_code")} value={postal_code} uppercase maxLength={10} width={105} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Ctry</Label>
                    <Input {...editProps("country")} value={country} uppercase maxLength={12} width={233} />
                    <Label style={{ "fontSize": "14px", "textAlign": "left" }} width={171}><nobr><em><a><CopyIcon />&nbsp; Copy Address</a></em></nobr></Label>
                    <Label grow><nobr>OL Act#</nobr></Label>
                    <Input {...editProps("san")} value={san} maxLength={7} width={87} />
                    <Label width={20}>Rep</Label>
                    <Input {...editProps("rep")} value={rep} uppercase maxLength={4} width={45} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Class</Label>
                    <Input {...editProps("interest_1")} value={interest_1} maxLength={8} width={107} />
                    <Input {...editProps("interest_2")} value={interest_2} maxLength={8} width={107} />
                    <Input {...editProps("interest_3")} value={interest_3} maxLength={8} width={107} />
                    <Input {...editProps("interest_4")} value={interest_4} maxLength={8} width={107} />
                    <Label style={{ "fontSize": "14px", "textAlign": "right" }} width={176}><nobr><em><a>Shipping Addresses</a></em></nobr></Label>
                </Space>
            </>
        )
    }

    const thisYear = dayjs().year();
    const lastYear = thisYear - 1;
    const prevYear = thisYear - 2;


    const drawExtra = () => {
        return (
            <>
                <Space grow style={{ alignItems: "start" }}>
                    <div style={{ "width": "100%" }}>
                        <Space grow size={8}>
                            <Label width={37}>BillTo</Label>
                            <Input grow {...editProps("bill_to")} value={bill_to} width={200} />
                        </Space>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Space size={8}>
                            <Label width={57}>Discount</Label>
                            <Space size={3}>
                                <Input {...editProps("discount")} value={discount} number maxLength={2} warning width={25} />
                                <Label>%</Label>
                            </Space>
                            <Label grow><nobr>A/R Total</nobr></Label>
                            <Input value="?" black width={60} />
                            <Input warning value="?" width={42} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={57}><nobr>Tax Code</nobr></Label>
                            <Input {...editProps("tax_group_code")} maxLength={4} value={tax_group_code} width={60} />
                            <Label grow shrink width={0}>CreditLim</Label>
                            <Input {...editProps("credit_limit")} number maxLength={6} value={credit_limit} width={60} />
                        </Space>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Tax#1</nobr></Label>
                            <Input grow {...editProps("tax_exempt")} value={tax_exempt} maxLength={10} width={90} />
                            <Label width={40}><nobr>Ship</nobr></Label>
                            <Input {...editProps("ship_via")} value={ship_via} width={120} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Tax#2</nobr></Label>
                            <Input grow {...editProps("tax_exempt_2")} value={tax_exempt_2} maxLength={10} width={90} />
                            <Label width={40}><nobr>Terms</nobr></Label>
                            <Input {...editProps("term")} value={term} width={120} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Card#</nobr></Label>
                            <Input grow value="1234567890" width={200} />
                        </Space>
                    </div>
                    <div>
                        <Card style={{ "width": "226px" }} secondary>
                            <Space size={8}>
                                <Label width={100}><nobr>Acct Created</nobr></Label>
                                <Input value={enter_date} medium black width={100} />
                            </Space>
                            <div className="shim" />
                            <Space size={8}>
                                <Label width={100}><nobr>Last Active</nobr></Label>
                                <Input value={last_order_date} medium width={100} />
                            </Space>
                            <div className="shim" /><div className="shim" style={{ "height": "6px" }} />
                            <Space size={3}>
                                <Label width={66}><nobr>Sales '{String(prevYear).slice(2)}</nobr></Label>
                                <Label width={66}><nobr>{lastYear}</nobr></Label>
                                <Label width={66}><nobr>{thisYear}</nobr></Label>
                            </Space>
                            <Space size={3}>
                                {/* <PriceField grow maxLength={7} {...editProps("sales_3")} right width={50} value={drawPrice(sales_3)} />
                                <PriceField grow maxLength={7} {...editProps("sales_last")} right width={50} value={drawPrice(sales_last)} />
                                <PriceField grow maxLength={7} {...editProps("sales_this")} right width={50} value={drawPrice(sales_this)} /> */}
                                <Input value={drawPrice(sales_3)} right medium black width={66} />
                                <Input value={drawPrice(sales_last)} right medium black width={66} />
                                <Input value={drawPrice(sales_this)} right medium black width={66} />
                            </Space>
                        </Card>
                        <div className="shim" />
                        <Card style={{ "width": "225px" }} secondary>
                            <Label style={{ "textAlign": "center" }}    >Frequent Buyer Status</Label>
                            <div className="shim" /><div className="shim" />
                            <Space size={8}>
                                <Label width={60}>Enabled?</Label>
                                <Input medium value={(frequent_buyer) ? "Yes" : "No"} width={25} />
                                <Label width={10}>$</Label>
                                <Input medium warning value={((isNaN(frequent_buyer_point) || frequent_buyer_point === 0) ? "0" : drawPrice(frequent_buyer_point/100))} width={65} />
                            </Space>
                            <div className="shim" />
                        </Card>
                    </div>
                </Space>
                <div className="shim" /><div className="shim" style={{ "height": "8px" }} />
                <Space size={8}>
                    <Label width={35}><nobr>Notes</nobr></Label>
                    <Input {...editProps("notes")} grow value={notes} width={203} />
                    <Label width={95}><nobr>Combine POs?</nobr></Label>
                    <Input {...editProps("combine_po")} value={combine_po} width={14} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={35}><nobr></nobr></Label>
                    <Input {...editProps("note")} grow value={note}  width={203} />
                    <Label width={95}><nobr>Get Deposit?</nobr></Label>
                    <Input {...editProps("get_deposit")} value={(get_deposit) ? "Y" : "N"} width={14} />
                </Space>
            </>
        )
    }

    return (
        <FocusWrap message={(drawMessage() && <Status type="active"><InfoIcon />{drawMessage()}</Status>)} style={{ "height": "auto" }} active={edit}>
            <div className="customer-card" onDoubleClick={() => {
                if (window.bm_state.value === ROUTES.CUSTOMER.CUSTOMER) {
                        switchEdit();
                    }
                }}>
                <Row>
                    <Row.Item flexShrink={1} flexGrow={1} minWidth={"570px"} width="626px" >
                        {drawCard()}
                    </Row.Item>
                    <div style={{ maxWidth: "20px", flexGrow: 1 }}></div>
                    <Row.Item flexShrink={1} flexGrow={1} width="612px" >
                        {drawExtra()}
                    </Row.Item>
                </Row>
            </div>
        </FocusWrap>
    )
}